import http from 'plugins/axios';

export default {
    addRecord(data) {
        return http.post({
            url: '/admin/refund/add',
            data
        });
    },

    reviewRecord(data) {
        return http.post({
            url: '/admin/refund/review',
            data,
            dataType: 'form'
        });
    },

    getAllRecord(data) {
        return http.get({
            url: '/admin/refund/list',
            data
        });
    },


    retryRecord(data) {
        return http.post({
            url: '/admin/refund/retry',
            data,
            dataType: 'form'
        })
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
